import Vue from 'vue'

const state = {
    ticketSizes:[
        {
            id: 0,
            label:"POS"
        },
        {
            id: 1,
            label:"A4"
        }
    ]
};

const getters = {
    getTicketTypes: (state) => state.ticketSizes,

};

const actions = {

};

const mutations = {


};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tickets.js